import { gql } from '@apollo/client';

export const PAGE_QUERY_BILLING_PERIOD_SUMMARY = gql`
  query PageQueryBillingPeriodSummary(
    $filters: BillingPeriodSummaryFilterInput
    $page: Int!
    $pageSize: Int!
  ) {
    pageQueryBillingPeriodSummary(filters: $filters, page: $page, pageSize: $pageSize) {
      list {
        id
        clientId
        clientName
        billingPeriod
        currency
        orderCount
        amount
        timezone
        baseFreight
        baseFreightAdj
        otherAdj
        otherAdjAdj
        overLengthFee
        overLengthFeeAdj
        overWeightFee
        overWeightFeeAdj
        deliveryFeeTt
        deliveryFeeTtAdj
        returnFeeTt
        claimAdj
        claimAdjAdj
        otherDecrease
        otherDecreaseAdj
      }
      total
    }
  }
`;
